export const environment = {
  production: true,
  api: 'https://nfmrecycling.jnarddc.gov.in/api/',
  clientUrl: 'https://nfmrecycling.jnarddc.gov.in/',
  imageurl: 'https://jnardcportal.s3.ap-south-1.amazonaws.com/',
};
